import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';

function firstThumb(project) {
  const m0 = Array.isArray(project?.media) ? project.media[0] : null;
  if (!m0) return '';
  return m0.image || m0.src || '';
}

export default function WorkIndexPage() {
  const { data, loading } = useData();

  useEffect(() => {
    document.body.classList.add('page-work');
    return () => document.body.classList.remove('page-work');
  }, []);

  useEffect(() => {
    if (data) {
      document.title = data.pages?.work?.meta?.title || 'Work — Preeyanka Mondal';
    }
  }, [data]);

  if (loading || !data) return null;

  const workPage = data.pages?.work || {};
  const work = data.work || [];

  return (
    <main className="work-index">
      <div className="wrap">
        <header className="work-index-header" aria-label="Work header">
          <h1 className="work-index-title">{workPage.title || 'Work'}</h1>
        </header>

        <section className="work-index-grid" aria-label="Work projects grid">
          {work.map((project) => {
            const thumb = firstThumb(project);
            return (
              <Link
                key={project.id}
                className="work-tile"
                to={`/work/${project.id}`}
                aria-label={project.title}
              >
                {thumb && (
                  <img
                    loading="lazy"
                    decoding="async"
                    src={thumb}
                    alt={project.title}
                  />
                )}
                <div className="overlay">
                  <div className="overlay-inner">
                    <span className="overlay-title">{project.title}</span>
                    <span className="overlay-subtitle">{project.subtitle}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </section>
      </div>
    </main>
  );
}
